import React from 'react'
import DashboardNav from './Components/DashboardNav'
import History from './Components/History'
import Footer from '../LandingPage/Components/Footer'

function UrlHistory() {
    return (
        <div>
            <DashboardNav />
            <History />
            <Footer />
        </div>
    )
}

export default UrlHistory